/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Statement from '../Statement/Statement';
import './SpannedStatement.scss';

/**
 * This is the SpannedStatement component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function SpannedStatement({ text, limit }) {
  return (
    <Statement className="block spanned-statement" limit={limit}>
      {text}
    </Statement>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
SpannedStatement.propTypes = {
  text: PropTypes.string,
  limit: PropTypes.number.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
SpannedStatement.defaultProps = {
  text: '',
  limit: 50,
};

export default SpannedStatement;
